module.exports = __webpack_public_path__ + "static/img/son5_active.2cd4fde7.jpg";